import { colors, hexToRGBA } from '../colors';

const light = {
  name: 'main',
  colors: {
    danger: colors.red,
    divider: colors.gray[200],
    logo: colors.darkGray[400],
    logoHeader: colors.darkGray[600],
    primary: colors.darkGray[600],
    success: colors.green,

    bg: {
      primary: colors.white,
      secondary: hexToRGBA(colors.darkGray[400], 0.1),
      contrast: colors.gray[900],
    },

    header: {
      bg: colors.darkGray[600],
      text: colors.yellowGreen[500],
    },

    footer: {
      bg: colors.darkGray[600],
      text: colors.yellowGreen[500],
    },

    info: {
      primary: colors.darkGray[500],
      secondary: colors.darkGray[400],
      highlight: colors.yellowGreen[500],
      light: colors.white,
      danger: colors.red,
    },

    checkbox: {
      primary: colors.darkGray[600],
      secondary: colors.white,
    },
  },

  font: {
    family: {
      primary: 'Arboria Book, sans-serif',
      bold: 'Arboria Bold, sans-serif',
      light: 'Arboria Light, sans-serif',
    },
    size: {
      xxSmall: '0.563rem', // 9px
      xSmall: '0.75rem', // 12px
      small: '0.875rem', // 14px
      base: '1rem', // 16px
      medium: '1.125rem', // 18px
      large: '1.5rem', // 24px
      xLarge: '1.875rem', // 30px
      xxLarge: '2.75rem', // 48px

      xSmallCalc: 'calc(0.875em + 0.2vh)',
      smallCalc: 'calc(1em + 0.2vh)',
      mediumCalc: 'calc(1em + 0.5vh)',
    },
  },
  breakpoints: {
    sm: '480px',
    md: '820px',
    h: {
      sm: '650px',
      md: '760px',
    },
  },
};

export default light;
